
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.573 3.312c.293-.043.59.03.83.198l.078.06 1.374 1.153a1.156 1.156 0 01.121 1.653l-.068.07-.702.667.049.084c.226.366.496.702.806 1.001l.158.147.164.14c.436.375.93.674 1.463.886l.09.034.535-.807c.146-.22.36-.382.607-.462l.095-.026.096-.018c.294-.042.59.03.83.199l.079.06 1.374 1.152a1.156 1.156 0 01.185 1.573l-.062.077-.07.074a4.633 4.633 0 01-3.18 1.271 4.433 4.433 0 01-1.562-.282 8.417 8.417 0 01-2.408-1.433 8.414 8.414 0 01-1.85-2.156 4.555 4.555 0 01.15-4.78 1.18 1.18 0 01.818-.535zm.167.96l-.027.001a.188.188 0 00-.132.086 3.589 3.589 0 00-.137 3.777 7.443 7.443 0 001.635 1.903 7.444 7.444 0 002.125 1.267 3.611 3.611 0 003.51-.588l.11-.094.112-.102a.184.184 0 00.018-.247l-.027-.027-1.374-1.153a.184.184 0 00-.247.01l-.025.03-.625.944a.76.76 0 01-.865.306A6.164 6.164 0 016.758 9.23a6.174 6.174 0 01-1.494-1.806.759.759 0 01.1-.846l.053-.055.822-.78a.185.185 0 00.018-.248l-.027-.028-1.374-1.153a.18.18 0 00-.116-.043z"}})])
          )
        }
      }
    